/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { EmailNotificationTableFragmentDoc } from '../../../../../components/organization/EmailNotification/__generated__/EmailNotificationTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type EmailNotificationsPageQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID'];
}>;


export type EmailNotificationsPageQuery = { __typename: 'Query', customer?: { __typename: 'Customer', id: string, name: string, notification?: { __typename: 'NotificationSettingsModel', id: string, emailAddresses: Array<string>, status: Types.NotificationStatus, customerId: string, settings: Array<{ __typename: 'NotificationItem', status: Types.NotificationStatus, alertType: Types.NotificationAlertType, reminderType: Types.NotificationReminderType, notificationType: Types.NotificationType }> } | null } | null };

export type UpdateNotificationSettingsMutationVariables = Types.Exact<{
  input: Types.NotificationInput;
}>;


export type UpdateNotificationSettingsMutation = { __typename: 'Mutation', notificationSettingsUpdate: { __typename: 'NotificationSettingsModel', id: string } };

export type UpdateNotificationStatusMutationVariables = Types.Exact<{
  input: Types.NotificationStatusInput;
}>;


export type UpdateNotificationStatusMutation = { __typename: 'Mutation', notificationStatusUpdate: { __typename: 'NotificationSettingsModel', id: string, status: Types.NotificationStatus } };


export const EmailNotificationsPageDocument = gql`
    query EmailNotificationsPage($customerId: ID!) {
  customer(id: $customerId) {
    id
    name
    notification {
      id
      emailAddresses
      status
      customerId
      ...EmailNotificationTable
    }
  }
}
    ${EmailNotificationTableFragmentDoc}`;

/**
 * __useEmailNotificationsPageQuery__
 *
 * To run a query within a React component, call `useEmailNotificationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailNotificationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailNotificationsPageQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useEmailNotificationsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EmailNotificationsPageQuery, EmailNotificationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EmailNotificationsPageQuery, EmailNotificationsPageQueryVariables>(EmailNotificationsPageDocument, options);
      }
export function useEmailNotificationsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EmailNotificationsPageQuery, EmailNotificationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EmailNotificationsPageQuery, EmailNotificationsPageQueryVariables>(EmailNotificationsPageDocument, options);
        }
export type EmailNotificationsPageQueryHookResult = ReturnType<typeof useEmailNotificationsPageQuery>;
export type EmailNotificationsPageLazyQueryHookResult = ReturnType<typeof useEmailNotificationsPageLazyQuery>;
export type EmailNotificationsPageQueryResult = ApolloReactCommon.QueryResult<EmailNotificationsPageQuery, EmailNotificationsPageQueryVariables>;
export const UpdateNotificationSettingsDocument = gql`
    mutation updateNotificationSettings($input: NotificationInput!) {
  notificationSettingsUpdate(input: $input) {
    id
  }
}
    `;
export type UpdateNotificationSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;

/**
 * __useUpdateNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingsMutation, { data, loading, error }] = useUpdateNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>(UpdateNotificationSettingsDocument, options);
      }
export type UpdateNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;
export const UpdateNotificationStatusDocument = gql`
    mutation updateNotificationStatus($input: NotificationStatusInput!) {
  notificationStatusUpdate(input: $input) {
    id
    status
  }
}
    `;
export type UpdateNotificationStatusMutationFn = ApolloReactCommon.MutationFunction<UpdateNotificationStatusMutation, UpdateNotificationStatusMutationVariables>;

/**
 * __useUpdateNotificationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationStatusMutation, { data, loading, error }] = useUpdateNotificationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNotificationStatusMutation, UpdateNotificationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNotificationStatusMutation, UpdateNotificationStatusMutationVariables>(UpdateNotificationStatusDocument, options);
      }
export type UpdateNotificationStatusMutationHookResult = ReturnType<typeof useUpdateNotificationStatusMutation>;
export type UpdateNotificationStatusMutationResult = ApolloReactCommon.MutationResult<UpdateNotificationStatusMutation>;
export type UpdateNotificationStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNotificationStatusMutation, UpdateNotificationStatusMutationVariables>;